'use client';
import { isSingularIdent } from './idents.js';
import { createPrefixer } from './utils/prefixer.js';

var listPrefixer = createPrefixer("#l.");
var identPrefixer = createPrefixer("#i.");
/**
 * Обёртка над `KVStorage`. Используется для ведения реестра кэшей списков.
 *
 * @note
 * Не безопасно для использования на сервере,
 * должна выполняться проверка среды исполнения.
 * */ var ListCache = function(kvRegistry) {
    return {
        persist: function(param, data) {
            var ident = param.ident, key = param.key;
            if (isSingularIdent(ident)) {
                var identKey = identPrefixer.prefixed(String(ident));
                kvRegistry.persist(identKey, data);
            } else {
                var listLookupKey = listPrefixer.prefixed(key);
                kvRegistry.persist(listLookupKey, data);
            }
        },
        restore: function(param) {
            var ident = param.ident, key = param.key;
            if (isSingularIdent(ident)) {
                var identKey = identPrefixer.prefixed(String(ident));
                return kvRegistry.restore(identKey);
            }
            var listLookupKey = listPrefixer.prefixed(key);
            return kvRegistry.restore(listLookupKey);
        }
    };
};

export { ListCache };
